import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDStack, FDImage } from '@facet-wealth/design';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { dataAttrs } from 'Helpers/Testing';
import { TooltipSmall } from 'Packages/FacetDesign/Components/Tooltip';
import { Amount } from './Amount';

const overrideFD = { ordinal: overrideReadOnly.ordinal + 1 };

const overrides = buildFacetDesignOverride()
  .overrideAll({
    _component: () => FDBodyText,
    _customProps: { size: 'lg' },
  }, overrideFD)
  .nameOverride('tooltip', {
    _component: () => TooltipSmall,
  }, overrideFD)
  .nameOverride('amount', {
    _component: () => Amount,
    _customProps: { strikethrough: false },
  }, overrideFD)
  .nameOverride('amountBeforeDiscount', {
    _component: () => Amount,
    _customProps: { strikethrough: true },
  }, overrideFD)
  .done();

export function LineItems({ collection }) {
  return (
    <>
      {
        collection.resources().list().map((resource) => (
          <FDStack
            justifyContent="space-between"
            spacing={3}
            key={resource.id()}
            {...dataAttrs('line item', resource)}
          >
            <FDStack spacing={1} alignItems="center">
              <MetaControl metaOverrideSet={overrides} resource={resource} attrName="title" />
              {resource.withRelationship(
                fr.relationships.icon.name,
                (rel) => (
                  <FDImage
                    src={rel.link('related').url()}
                    // relationships don't contain alts, so this is what I'm doing for now
                    alt="Facet icon made to represent the level of service you have chosen"
                    // TODO: solve this by using 1em instead, which can't be done today because we can't put the <img> inside of the FDHeadlineText
                    height="18px"
                  />
                ),
                () => null,
              )}
              <MetaControl metaOverrideSet={overrides} resource={resource} attrName="tooltip" />
            </FDStack>
            <FDStack justifyContent="flex-end" spacing={1}>
              <MetaControl metaOverrideSet={overrides} resource={resource} attrName="amountBeforeDiscount" />
              <MetaControl metaOverrideSet={overrides} resource={resource} attrName="amount" />
            </FDStack>
          </FDStack>
        ))
      }
    </>
  );
}

LineItems.defaultProps = {
};

LineItems.propTypes = {
  collection: PropTypes.object.isRequired,
};
